export const REGEX = {
    NO_SPACE_HYPHEN_AT_START : /^(?!^[ #-]+$)[-# /A-Za-z\d]{1,50}$/,
    CERTIFICATE_OF_NATURALIZATION : /^[A-Za-z\d]{8,50}$/,
    DRIVER_LICENSE : /^(?!^[ #-]+$)[-# /A-Za-z\d]{1,15}$/,
    EMPLOYMENT_AUTHORIZATION_DOCUMENT_HYPHEN : /^(\d){3}-(\d){3}-(\d){3}$/,
    EMPLOYMENT_AUTHORIZATION_DOCUMENT_NO_HYPHEN : /^\d{9}$/,
    MARRIAGE_CERTIFICATE : /^(?!^[ #-]+$)[-# /A-Za-z\d]{4,50}$/,
    PERMANENT_RESIDENT_CARD : /^(?!^[ #-]+$)[-# /A-Za-z\d]{13,50}$/,
    SSN_HYPHEN : /^\d{3}-\d{2}-\d{4}$/,
    SSN_NO_HYPHEN : /^\d{9}$/,
    PASSPORT : /^(?!^[ #-]+$)[-# /A-Za-z\d]{9,50}$/,
    BIRTH_RECORD : /^(?!^[ #-]+$)[-# /A-Za-z\d]{11,50}$/
};